import React from "react";
import Breadcrumb, { type BreadcrumbItem } from "@/design-system/Molecules/Breadcrumbs";

interface BreadcrumbsContainerProps {
    items: BreadcrumbItem[];
    className?: string;
}

const BreadcrumbsContainer: React.FC<BreadcrumbsContainerProps> = ({ items, className }) => {
    return (
        <Breadcrumb items={items} className={className} />
    );
};

export default BreadcrumbsContainer;
